import useAccountInformation from '@/auth/hooks/useAccountInformation'
import {getCustomerSession} from '@/lib/payment/paymentService'

export default function useCustomerSession() {
  const [account] = useAccountInformation()

  return useQuery({
    queryKey: ['customerSession', account?.id],
    queryFn: account?.id ? async () => getCustomerSession({}) : skipToken,
    refetchInterval: 30 * 60 * 1000, // 30 minutes
    refetchIntervalInBackground: false,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  })
}
